import {api} from '../../api/access-ctrl'
import {
  registerConfig, ROUTE_NAME_OF_DI_PAGE
} from '../../../components/common/di-ding'
import {commonConfig, routeNameOfDi} from '../common'
import Vue from 'vue'
import ButtonDelete from '../../../components/common/buttons/button-delete'
import ButtonAuth from '../../../components/common/buttons/button-auth'
import ButtonAuthNew from '../../../components/common/buttons/button-auth-new'
import {nTipFunc, nWarn} from '../../../utils/notice'
import {errorHandler} from '../../../utils/errorHandler'

Vue.component('button-delete', ButtonDelete)
Vue.component('button-auth', ButtonAuth)
Vue.component('button-auth-new', ButtonAuthNew)

export const mapping = {
  enterpriseName: '住户名称',
  deviceName: {
    label: '门禁'
  }
}

const config = {
  breadcrumb: [{
    value: '智慧门禁',
    name: 'accessCtrlDeviceManagementCenter'
  }, {
    value: '门禁授权',
  }],
  center: {
    searchTree: {
      searchKey: 'deviceId',
      searchType: 'code'
    },
    opBar: [ // 多少个元素代表多少行
      [
        {
          type: 'render',
          renderContent (h, type, data, that) {
            return <button-auth-new
              value="添加授权"
              deviceUse="2"
              onthis={that}
              iconClassName="el-icon-minus"
            />
          }
        },
        {
          type: 'render',
          renderContent (h, type, data, that) {
            const handleClick = () => {
              // let devType = window.sessionStorage.getItem('devType')
              // if (!devType) {
              //   nWarn('请先选择需要解绑的设备')
              //   return
              // }
              if (that.selected.length === 0) {
                nWarn('请先选择需要解绑的对象')
                return
              }
              that.$confirm('确认解绑？')
                .then(
                  () => {
                    let ids = that.selected.map(s => s.code).join(',')
                    let resData = []
                    resData = ids.split(',')
                    api.deleteAuthorityForEnterprise(resData)
                      .then(nTipFunc('解绑成功'))
                      .then(() => {
                        that.getData()
                      })
                  },
                  () => {
                    console.debug('用户取消了解绑')
                  }
                )
                .catch(errorHandler('请求失败'))
            }
            return <button-delete
              value="删除授权"
              onClick={handleClick}
              iconClassName="el-icon-minus"
            />
          },
        },
        {
          type: 'button-cancel',
          label: '查看人员',
          onClick () {
            this.routerPush(ROUTE_NAME_OF_DI_PAGE.CENTER, {diName: routeNameOfDi.APP_CENTER_ACCESS_CTRL_EMPOWERMENT})
          }
        },
        {type: 'input-search', label: '住户名称', searchKey: 'searchKey'},
        // {
        //   type: 'button-download',
        //   label: '导出',
        //   getDownloadUrl: (requestBody) => api.exportAuthorityInfo(requestBody),
        //   download: '授权列表'
        // }
      ]
    ],
    table: {
      selectBox: true,
      operations: [{
        renderContent (h, pageType, data, vm) {
          const handleDelete = () => {
            let sendData = []
            sendData.push(data.code)
            vm.$confirm('确认删除？')
              .then(
                () =>
                  api.deleteAuthorityForEnterprise(sendData)
                    .then(nTipFunc('删除成功'))
                    .then(vm.getData)
                ,
                () => {
                  console.debug('用户取消了删除')
                }
              )
              .catch(errorHandler('请求失败'))
          }
          return <a onClick={handleDelete}>删除授权</a>
        }
      }]
    }
  },

  get: requestBody => api.getAuthorityForEnterprise(requestBody),
  delete: strId => api.deleteAuthorityForEnterprise(strId),

  mapping
}

registerConfig(routeNameOfDi.APP_CENTER_ACCESS_CTRL_EMPOWERMENT_ENTERPRISE, config)



// WEBPACK FOOTER //
// ./src/view/AccessCtrl/authority/authority-enterprise.js